export enum CommunicationsPostTypes {
  private = 1,
  public = 2
}
